import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/time-to-finish.png'
import _imports_1 from '@/assets/time.svg'


const _hoisted_1 = {
  key: 0,
  class: "progress-bar"
}
const _hoisted_2 = {
  key: 0,
  class: "image",
  src: _imports_0,
  alt: "time to finish onboarding"
}
const _hoisted_3 = {
  key: 1,
  class: "image",
  src: _imports_1,
  alt: "time to finish onboarding"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "time-to-finish" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisibleProgressBar)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.isOandaPath)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.isOandaPath)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.toFinish`)) + " ", 1),
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.timeToFinish) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.${_ctx.adjustTextProgressBar()}`)), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}